import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";

export const OrderState = createSlice({
  name: "orderState",
  initialState: {
    showOrderModal: false,
    orderItems: [],
    initialOrderItems: [],
    orderData: [],
    orderDate: null,
    orderStatus: "",
    selectedItem: null,
    selectedSupplier: null,
    showServiceModal: false,
    areChangesMade: false,
    obj: {},
    showObjModal: false,
  },
  reducers: {
    closeObjModal: (state) => {
      state.showObjModal = false;
    },
    showObjModal: (state) => {
      state.showObjModal = true;
    },
    setOBJ: (state, action) => {
      state.obj = action.payload;
    },
    clearOBJ: (state) => {
      state.obj = [];
    },
    setOrderData: (state, action) => {
      state.orderData = action.payload;
    },
    setInitialOrderItems: (state, action) => {
      // Ensure action.payload is an array (fallback to empty array if undefined)
      const payload = Array.isArray(action.payload) ? action.payload : [];

      // Concatenate the arrays
      const combinedInitialOrderItems = _.concat(
        state.initialOrderItems || [],
        payload
      );
      const combinedOrderData = _.concat(state.orderData || [], payload);

      // Remove duplicates using a Set
      state.initialOrderItems = Array.from(
        new Set(combinedInitialOrderItems.map((item) => JSON.stringify(item)))
      )
        .map((item) => {
          try {
            return JSON.parse(item);
          } catch (error) {
            console.error("Error parsing JSON:", error);
            return null; // Skip invalid items
          }
        })
        .filter((item) => item !== null); // Remove null values

      state.orderData = Array.from(
        new Set(combinedOrderData.map((item) => JSON.stringify(item)))
      )
        .map((item) => {
          try {
            return JSON.parse(item);
          } catch (error) {
            console.error("Error parsing JSON:", error);
            return null; // Skip invalid items
          }
        })
        .filter((item) => item !== null); // Remove null values
    },
    setChanges: (state, action) => {
      state.areChangesMade = action.payload;
    },
    setShowServiceModal: (state, action) => {
      state.showServiceModal = action.payload;
    },
    setSelectedItem: (state, action) => {
      state.selectedItem = action.payload;
    },
    setSelectedSupplier: (state, action) => {
      state.selectedSupplier = action.payload;
    },
    SetOrderStatus: (state, action) => {
      state.orderStatus = action.payload;
    },

    setShowOrderModal: (state) => {
      state.showOrderModal = true;
    },
    setHideOrderModal: (state) => {
      state.showOrderModal = false;
    },
    addOrderItems: (state, action) => {
      state.orderItems = action.payload;
    },
    clearOrderItems: (state) => {
      state.orderItems = [];
    },
    removeItemFromOrder: (state, action) => {
      const orders = state.orderItems;
      state.orderItems = _.filter(
        orders,
        (order) => order.orderId !== action.payload
      );
    },
    deleteItemFromOrders: (state, action) => {
      const orderId = action.payload;
      const updated = _.filter(
        state.initialOrderItems,
        (obj) => obj.orderId != orderId
      );
      state.orderData = updated;
      state.initialOrderItems = updated;
    },
    addNewItemToOrder: (state, action) => {
      const { orderItem } = action.payload;
      const { itemId } = orderItem;
      const presState = [...state.orderItems].filter(
        (obj) => obj.itemId != itemId
      );
      state.orderItems = [...presState, orderItem];
    },
    updateOrder: (state, action) => {
      const { orderId, updatedProperties } = action.payload;
      state.orderItems = state.orderItems.map((order) =>
        order.orderId === orderId
          ? { ...order, ...updatedProperties } // Merge existing order with updated properties
          : order
      );
    },
    updateOrderStatus: (state, action) => {
      const { orderId, updatedProperties, applicationType } = action.payload;
      const update = state.orderData.map((order) => {
        return order.orderId === orderId &&
          order.applicationType === applicationType
          ? { ...order, ...updatedProperties } // Merge existing order with updated properties
          : order;
      });
      state.orderData = update;
      state.initialOrderData = update;
    },
    incrementQuantity: (state, action) => {
      const { orderId } = action.payload;
      const order = state.orderItems.find(
        (order) => order.ordered_item_id === orderId
      );

      if (order) {
        const { available_quantity, quantity } = order;

        if (available_quantity > quantity) order.quantity += 1; // Increment quantity
      }
    },
    decrementQuantity: (state, action) => {
      const { orderId } = action.payload;
      const order = state.orderItems.find(
        (order) => order.ordered_item_id === orderId
      );
      if (order && order.quantity > 1) {
        order.quantity -= 1; // Decrement quantity (ensure it doesn't go below 0)
      }
    },
  },
});

export const {
  setHideOrderModal,
  setShowOrderModal,
  clearOrderItems,
  removeItemFromOrder,
  updateOrder, // Export the new action
  SetOrderStatus,
  incrementQuantity,
  decrementQuantity,
  setSelectedItem,
  addNewItemToOrder,
  setShowServiceModal,
  addOrderItems,
  setChanges,
  setInitialOrderItems,
  updateOrderStatus,
  setOrderData,
  deleteItemFromOrders,
  setOBJ,
  clearOBJ,
  closeObjModal,
  showObjModal,
  setSelectedSupplier,
} = OrderState.actions;

export default OrderState.reducer;
